/** Catalog of assignable quick actions (id → route + label). */
export const DASHBOARD_QUICK_ACTION_CATALOG = {
  new_sale: { label: 'New Sale', path: '/sales/pos-keyboard' },
  purchase: { label: 'Purchase Entry', path: '/purchases/po-keyboard' },
  add_product: { label: 'Add Product', path: '/inventory/products' },
  stock_check: { label: 'Stock Check', path: '/reports/stock' },
  customer_dues: { label: 'Customer Dues', path: '/reports/credit-customers' },
  sales_report: { label: 'Sales Report', path: '/reports/location-sales' },
  invoice_pnl: { label: 'Invoice P&L', path: '/reports/invoice-profit-loss' },
  day_close: { label: 'Day Close', path: '/reports/day-close' },
  pos_settings: { label: 'POS Settings', path: '/settings/page-fields' },
};

export const DASHBOARD_FUNCTION_KEYS = ['F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9'];
